
import { useCollectionTracked } from "presentation/store/Collection/CollectionProvider";
import { SliderPanel } from "veronica-ui-component/dist/component/core";
import CollectionDtlEditTablePanel from "./CollectionDtlEditTablePanel";
import CollectionDtlTablePanel from "./CollectionDtlTablePanel";

export const CollectionDtlRightPanel: React.FC = () => {
    const [collectionState] = useCollectionTracked();
    const { isShowEditPanel } = collectionState;

    return <>
        <div className={`main-comp-wrapper${(isShowEditPanel) ? '' : ' im-hide-side-form-draggable'}`}>
            <SliderPanel
                isOpen={true}
                leftSectionWidth={isShowEditPanel ? '50%' : '100%'}
                rightSectionWidth={isShowEditPanel ? '50%' : '0%'}
                draggable={false}
                leftChildren={<CollectionDtlTablePanel />}
                rightChildren={<CollectionDtlEditTablePanel />}
            />
        </div>
    </>
}